<template>
  <div class="featured-content">
    <div
      v-if="noIntroContent"
      class="featured-content-wrapper"
    >
      <h2
        v-if="title"
        class="featured-content-title"
      >
        {{ title }}
      </h2>
      <p
        v-if="description"
        class="featured-content-description"
      >
        {{ description }}
      </p>
    </div>
    <div class="card-overview">
      <div class="grid grid-cols-1 md:grid-cols-3 md:gap-8 lg:gap-16">
        <kf-card
          v-for="(card, i) in cards"
          :key="i"
          :src="card.src"
          :link-url="card.linkUrl"
          :description="card.title"
          :centered="card.review"
          :review="card.review || false"
          :class="`card-${i}`"
        >
          <template #card-body>
            <kf-heading
              v-if="card.title"
              tag="h3"
              class="card-title"
            >
              {{ card.title }}
            </kf-heading>

            <p
              v-if="card.subtitle"
              class="card-subtitle"
            >
              {{ card.subtitle }}
            </p>

            <p
              v-if="card.description && truncateIntro"
              :class="{ italic: card.descriptionIsQuote }"
            >
              {{ card.description | truncate(109, '...') }}
            </p>
            <p
              v-if="card.description && !truncateIntro"
              :class="{ italic: card.descriptionIsQuote }"
            >
              {{ card.description }}
            </p>
            <span
              v-if="i18n && i18n.cardlabel"
              class="card-link-span"
            >
              {{ i18n.cardlabel }}
            </span>
            <span
              v-else-if="card.linkLabel"
              class="card-link-span"
            >
              {{ card.linkLabel }}
            </span>
          </template>
        </kf-card>
      </div>
    </div>
    <div
      v-if="link"
      class="featured-content-btns"
    >
      <kf-link
        v-if="link"
        :type="link.type"
        :href="link.href"
        :target="link.target"
        class="text-one-column-link"
      >
        {{ link.label }}
      </kf-link>
    </div>
  </div>
</template>

<script>
import KfHeading from '@/components/base/heading/Heading.vue';
import KfLink from '@/components/base/link/Link.vue';
import KfCard from '@/components/card/Card.vue';
import GlobalMixins from '@/mixins/GlobalMixins.js';

export default {
  name: 'KfFeaturedContent',
  components: {
    KfCard,
    KfHeading,
    KfLink,
  },
  mixins: [GlobalMixins],
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    descriptionIsQuote: {
      type: Boolean,
      default: false,
    },
    cards: {
      type: Array,
      default: null,
    },
    link: {
      type: Object,
      default: null,
    },
    truncateIntro: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    noIntroContent() {
      return this.title || this.description;
    },
    hasLink() {
      return this.link && this.link !== '';
    }
  }
};
</script>

<style lang="postcss">
.featured-content {
  @apply relative;

  &-wrapper {

    @screen md {
      @apply mx-auto max-w-3xl;
    }
  }

  &-title,
  &-description {
    @apply text-center;
  }

  &-description {
    @apply mb-8;
  }

  &-btns {
    @apply flex justify-center mt-8;

    @screen md {
      @apply mt-12;
    }
  }
}
</style>






